import {queryCache, useQuery} from "react-query";
import {get, PROJECTS} from "./Client";
import {useSelector} from "react-redux";

export function useGetSettings() {
	let venue = useSelector(store => store.session.venue);
	const {status, data, error} = useQuery(['settings', {venue: venue.id}], () =>
		get(`${PROJECTS}/${venue.id}/settings`)
	);
	return {status, settings: data || [], error};
}
export function useGetProjects() {
	const {status, data, error} = useQuery(['projects'], () =>
		get(`${PROJECTS}`)
	);
	return {status, projects: data || [], error};
}

export function usePrefetchContent() {
	// let venue = useSelector(store => store.session.venue);
	// venue && queryCache.prefetchQuery(["maps", {venue: venue.id}], () =>
	// 	get(MAPS, {params: {venue: venue.id}})
	// );
	// queryCache.prefetchQuery("venues", () => get(VENUES));
}

export function invalidate() {
	queryCache.removeQueries("settings");
	queryCache.removeQueries("maps");
}
